var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2622 1.01245C10.0631 0.813 9.79842 0.703125 9.5168 0.703125H9.04934V1.17188C9.04934 1.68881 8.62924 2.10938 8.11287 2.10938H3.89881C3.38243 2.10938 2.96234 1.68881 2.96234 1.17188V0.703125H2.49333C1.91306 0.703125 1.44047 1.17572 1.43981 1.75664L1.42969 10.9441C1.42936 11.2261 1.53881 11.4912 1.73782 11.6907C1.93688 11.8901 2.20158 12 2.4832 12H9.50665C10.0869 12 10.5595 11.5274 10.5602 10.9465L10.5703 1.75898C10.5706 1.47705 10.4612 1.21193 10.2622 1.01245Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66504 1.17188C3.66504 1.30132 3.76985 1.40625 3.89916 1.40625H8.11322C8.24252 1.40625 8.34734 1.30132 8.34734 1.17188V0.234375C8.34734 0.10493 8.24252 0 8.11322 0H3.89916C3.76985 0 3.66504 0.10493 3.66504 0.234375V1.17188Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9C5.81234 9 5.66029 8.84795 5.66029 8.66029V4.33971C5.66029 4.15205 5.81234 4 6 4C6.18766 4 6.33971 4.15205 6.33971 4.33971V8.66029C6.33971 8.84795 6.18766 9 6 9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16029 6.83971H3.83971C3.65205 6.83971 3.5 6.68766 3.5 6.5C3.5 6.31234 3.65205 6.16029 3.83971 6.16029H8.16029C8.34795 6.16029 8.5 6.31234 8.5 6.5C8.5 6.68766 8.34795 6.83971 8.16029 6.83971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTaskIcon);
export default __webpack_public_path__ + "static/media/AddTaskIcon.a37d07e4b2116295908a0e4334e7e253.svg";
export { ForwardRef as ReactComponent };